import {
  Actions,
  AddPageSuccess,
  PagesActionTypes,
} from '../../_actions/settings/pages.action';
import { Operations, OpTypes } from '../../_models/general.model';
import { Pages } from '../../_models/settings.models';

/**
 * State interface
 */
export interface PagesState {
  defaultPage: any;
  pages: {
    [key: string]: Array<Pages>;
  };
  pageDetails: {
    [appId: string]: {
      [pageId: string]: {};
    };
  };
  error: {} | null;
  operations: Operations;
  pagesLoading:{[key:string]:boolean}
}

/**
 * Initials State
 */
export const initialState: PagesState = {
  pages: {},
  pageDetails: {},
  error: null,
  operations: {},
  defaultPage: {},
  pagesLoading:{}
};

/**
 * Reducer
 */
export const PagesReducers = (
  state = initialState,
  action: Actions
): PagesState => {
  switch (action.type) {
    case PagesActionTypes.LOAD_PAGES:
      return{
        ...state,
        pagesLoading:{...state.pagesLoading, [action.applicationId]:true, [`error-${action.applicationId}`]:false}
      }
    case PagesActionTypes.COPY_PAGE_SUCCESS:
      return {
        ...state,
        operations: {
          ...state.operations,
          [action.refId]: {
            type: OpTypes.CREATE,
            error: null,
          },
        },
      };
    case PagesActionTypes.COPY_PAGE_FAILED:
      return {
        ...state,
        operations: {
          ...state.operations,
          [action.refId]: {
            type: OpTypes.FAILED,
            error: action.payload,
          },
        },
        error: action.payload,
      };
    case PagesActionTypes.LOAD_PAGES_SUCCESS:
      return {
        ...state,
        pages: {
          ...state.pages,
          [action.applicationId]: action.payload,
        },
        pagesLoading:{...state.pagesLoading, [action.applicationId]:false, [`error-${action.applicationId}`]:false}
      };
    case PagesActionTypes.ADD_PAGE_SUCCESS:
      const pages = [
        ...(state.pages[Number(action.payload.ApplicationKey)] || []),
      ];
      pages.push(<Pages>action.payload);
      pages.sort((a, b) => a.Title.localeCompare(b.Title));
      return {
        ...state,
        pages: {
          ...state.pages,
          [action.payload.ApplicationKey]: pages,
        },
        operations: {
          ...state.operations,
          [action.refId]: {
            type: OpTypes.CREATE,
            error: null,
          },
        },
      };

    case PagesActionTypes.LOAD_PAGE_SUCCESS:
      return {
        ...state,
        pageDetails: {
          ...state.pageDetails,
          [action.appId]: {
            ...state.pageDetails[action.appId],
            [action.pageId]: action.payload,
          },
        },
      };
    case PagesActionTypes.LOAD_DEFAULT_PAGE_FOR_TABLE_SUCCESS:
      return {
        ...state,
        defaultPage: {
          ...state.defaultPage,
          // [action.tableId]: {
          // ...state.defaultPage[action.tableId],
          [action.tableId]: action.payload,
          // },
        },
      };

    case PagesActionTypes.UPDATE_PAGE_SUCCESS:
      const updatedPages: Array<Pages> = [
        ...(state.pages[Number(action.payload.ApplicationKey)] || []),
      ];

      const foundIndex = updatedPages.findIndex(
        (page) => page.Key == action.payload.Key
      );
      if (foundIndex > -1) {
        updatedPages.splice(foundIndex, 1);
        updatedPages.push(action.payload);
      }
      updatedPages.sort((a, b) => a.Title.localeCompare(b.Title));

      return {
        ...state,
        pages: {
          ...state.pages,
          [action.payload.ApplicationKey]: updatedPages,
        },
        operations: {
          ...state.operations,
          [action.refId]: {
            type: OpTypes.UPDATE,
            error: null,
          },
        },
      };

    case PagesActionTypes.DELETE_PAGE_SUCCESS:
      const index = state.pages[action.appId]?.findIndex(
        (page) => page.Key == action.pageId
      );

      return {
        ...state,
        pages: {
          ...state.pages,
          [action.appId]: [
            ...state.pages[action.appId].slice(0, index),
            ...state.pages[action.appId].slice(index + 1),
          ],
        },
        operations: {
          ...state.operations,
          [action.refId]: {
            type: OpTypes.DELETE,
            error: null,
          },
        },
      };

    case PagesActionTypes.ADD_PAGE_FAILED:
    case PagesActionTypes.UPDATE_PAGE_FAILED:
    case PagesActionTypes.DELETE_PAGE_FAILED:
      return {
        ...state,
        operations: {
          ...state.operations,
          [action.refId]: {
            type: OpTypes.FAILED,
            error: action.payload,
          },
        },
        error: action.payload,
      };
    case PagesActionTypes.LOAD_PAGES_FAILED:
      return{
        ...state,
        pages:{},
        error: action.payload,
        pagesLoading:{...state.pagesLoading, [action.applicationId]:false, [`error-${action.applicationId}`]:true}
      }
    case PagesActionTypes.LOAD_PAGE_FAILED:
      return {
        ...state,
        pages: {},
        error: action.payload,
      };
    case PagesActionTypes.RESET:
      return initialState;

    default:
      return state;
  }
};
